export default {
    data(){
    },
    methods: {
        focusInput(this_, inputId) {
			setTimeout(() => {
				if (this_.$refs[inputId]) {
					if (this_.$refs[inputId].$refs["ref-input-" + inputId]) {
						this_.$refs[inputId].$refs["ref-input-" + inputId].focus();
					}
				}
			}, 50);
		},
    }
  };